var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 18C19 18.5523 18.5523 19 18 19H12.7143C12.162 19 11.7143 18.5523 11.7143 18V12.7143C11.7143 12.162 12.162 11.7143 12.7143 11.7143H18C18.5523 11.7143 19 12.162 19 12.7143V18ZM9.28571 18C9.28571 18.5523 8.838 19 8.28571 19H3C2.44771 19 2 18.5523 2 18V12.7143C2 12.162 2.44772 11.7143 3 11.7143H8.28572C8.838 11.7143 9.28571 12.162 9.28571 12.7143V18ZM19 8.28572C19 8.838 18.5523 9.28571 18 9.28571H12.7143C12.162 9.28571 11.7143 8.838 11.7143 8.28571V3C11.7143 2.44771 12.162 2 12.7143 2H18C18.5523 2 19 2.44772 19 3V8.28572ZM9.28571 8.28572C9.28571 8.838 8.838 9.28571 8.28571 9.28571H3C2.44771 9.28571 2 8.838 2 8.28571V3C2 2.44771 2.44772 2 3 2H8.28572C8.838 2 9.28571 2.44772 9.28571 3V8.28572Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApp);
export default __webpack_public_path__ + "static/media/app.c0c008f4f4abc3e6e12640d9e338d353.svg";
export { ForwardRef as ReactComponent };